import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import type {Bloque} from '@/lib/perfil-bloques'

/** Un «Agregar» por bloque (KAI-144), igual en las tres tarjetas. */
export function CabeceraDeBloque({
  bloque,
  ayuda,
  editable,
  pending,
  onAgregar,
}: {
  bloque: Bloque
  ayuda?: ReactNode
  editable: boolean
  pending: boolean
  onAgregar: (bloque: Bloque) => void
}) {
  const {t} = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <h3 className="font-heading text-base tracking-tight">{t(`perfilCargo.bloque.${bloque}`)}</h3>
      {ayuda}
      {editable && (
        <Button
          className="ml-auto"
          size="sm"
          variant="outline"
          disabled={pending}
          data-testid={`agregar-${bloque}`}
          onClick={() => onAgregar(bloque)}>
          {t('perfilCargo.detalle.agregarLinea')}
        </Button>
      )}
    </div>
  )
}
